module.exports = __webpack_public_path__ + "static/media/pm10_v2.c2bdc9be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/weather/svg/pm10_v2.svg
// module id = 510
// module chunks = 0